// CSS filter chains that recolour a black glyph (solved via backend/scripts/solve_css_filters.py)
export const TINTS = [
  { id: 'black', label: 'Black', hex: '#0A0A0A', filter: 'none' },
  { id: 'white', label: 'White', hex: '#FFFFFF', filter: 'brightness(0) invert(1)' },
  { id: 'red', label: 'Red', hex: '#E63946', filter: 'brightness(0) saturate(100%) invert(53%) sepia(84%) saturate(6042%) hue-rotate(335deg) brightness(92%) contrast(95%)' },
  { id: 'blue', label: 'Blue', hex: '#2563EB', filter: 'brightness(0) saturate(100%) invert(28%) sepia(56%) saturate(4902%) hue-rotate(218deg) brightness(98%) contrast(89%)' },
  { id: 'mint', label: 'Mint', hex: '#2EC4A0', filter: 'brightness(0) saturate(100%) invert(71%) sepia(30%) saturate(1052%) hue-rotate(112deg) brightness(91%) contrast(76%)' },
];

export const TINTABLE_CATEGORIES = ['alphabet', 'numbers-symbols'];

export const tintFilter = (id) => TINTS.find((t) => t.id === id)?.filter || 'none';
